import {
	Component,
	Directive,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
// SERVICES
import { AlertService } from '@services/notification/alert.service';
// MODELS
// BASE
import { FormBase } from '@base/FormBase';
import { Response } from '@models/response-api/ResponseApi';
import { HttpErrorResponse } from '@angular/common/http';
import { QuestionTypeService } from '@services/question-type/question-type.service';
import { CatalogBase } from '@models/catalog/Catalog';
import { Question } from '@models/question/Question';
import { QuestionBank } from '@models/question-bank/QuestionBank';
import { ActivatedRoute, Router } from '@angular/router';
import { toBase64 } from '@utils/to-base-64';

@Directive({selector: 'reagent-form-base'})
export abstract class ReagentFormBase extends FormBase implements OnInit, OnDestroy {
	subscription = new Subscription();
	form!: FormGroup;
	questionBank: QuestionBank;
	questionsTypes: CatalogBase[] = [];
	@Output() save = new EventEmitter();
	@Output() update = new EventEmitter();
	@Output() changeQuestionDraft = new EventEmitter();
	_question?: Question;
	@Input() set question(value: Question | undefined) {
		if (value) {
			this._question = value;
			this.setQuestion(value);
		}
	}

	constructor(
		private fb: FormBuilder,
		private alertService: AlertService,
		private questionTypeService: QuestionTypeService,
		protected route: ActivatedRoute,
		protected router: Router,
	) {
		super();
		this.questionBank = this.route.parent?.snapshot.data['data'] as QuestionBank;
		this.createForm();
		this.loadQuestionType();
	}

	ngOnInit() {}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	navigateToRegents() : void {
		this.router.navigate([
			'/app/reagent-generator/question-bank',
			this.questionBank.id,
			'reagents',
		]);
	}

	createForm() {
		this.form = this.fb.group({
			id: null,
			questionBankId: [this.questionBank.id, [Validators.required]],
			content: ['', [Validators.required]],
			explanation: ['', [Validators.required]],
			questionTypeId: [null, [Validators.required]],
			active: true,
			filename: [''],
			fileContentBase64: [null],
			urlImage: [null],
		});
	}

	setQuestion(question: Question) {
		this.form.setValue({
			id: question.id,
			questionBankId: question.questionBankId,
			content: question.content,
			explanation: question.explanation,
			questionTypeId: question.questionTypeId,
			active: true,
			filename: question.filename || null,
			fileContentBase64: null,
			urlImage: question?.urlImage || '',
		});
	}

	async changeFile($event: Event, elementRef: HTMLInputElement) {
		const file = this.getFile($event);
		if (file) {
			const sizeMb = file.size / 1024 / 1024;
			if (sizeMb < 1) {
				const encoded = await toBase64(file);
				const image64 = (encoded as string).replace(/^data:(.*,)?/, '');
				this.formControl('filename').setValue(file.name);
				this.formControl('fileContentBase64').setValue(image64);
				this.formControl('urlImage').setValue(encoded);
			} else {
				this.alertService.showError('Imagen demasiado grande, máximo 1MB');
				this.deleteImage();
				elementRef.value = '';
			}
		}
	}

	deleteImage() {
		this.formControl('filename').setValue(null);
		this.formControl('fileContentBase64').setValue(null);
		this.formControl('urlImage').setValue('');
	}

	changeQuestionType() {
		this.changeQuestionDraft.emit(this.form.value);
	}

	loadQuestionType() {
		this.subscription.add(
			this.questionTypeService.getAll().subscribe({
				next: (x: Response) => {
					this.questionsTypes = x.data as CatalogBase[];
				},
				error: (error: HttpErrorResponse) => {
					console.log(error);
					this.alertService.showSmallErrorServer();
				},
			})
		);
	}

	onSubmit($event: Event) {
		$event.preventDefault();
		this.formSubmitted = true;
		if (this.form.valid) {
			const value = this.form.value;
			this._question ? this.update.emit(value) : this.save.emit(value);
		} else {
			this.alertService.showErrorForm();
		}
	}
}
